import { forwardRef } from 'react'
import { Tab as AriaTab, TabList as AriaTabList, TabPanel as AriaTabPanel, Tabs as AriaTabs } from 'react-aria-components'
import { cn } from '@/lib/utils'

const Tabs = forwardRef(({ children, className, ...props }, ref) => {
  return (
    <AriaTabs
      ref={ref}
      className={cn(
        'flex flex-col gap-2',
        className,
      )}
      {...props}
    >
      {children}
    </AriaTabs>
  )
})
Tabs.displayName = 'Tabs'

const TabsList = forwardRef(({ children, className, ...props }, ref) => {
  return (
    <AriaTabList
      ref={ref}
      className={cn(
        'flex items-center gap-1.5',
        className,
      )}
      {...props}
    >
      {children}
    </AriaTabList>
  )
})
TabsList.displayName = 'TabsList'

const Tab = forwardRef(({ children, className, icon: Icon, ...props }, ref) => {
  return (
    <AriaTab
      ref={ref}
      className={cn(
        'inline-flex items-center justify-center p-2 gap-1 rounded-sm cursor-pointer',
        'text-foreground uppercase font-bold text-2xs',
        'border border-light hover:bg-hover-light-8 pressed:bg-menu-select selected:bg-menu-select selected:hover:bg-hover-light-8 selected:pressed:bg-medium-dark',
        'hover:border-transparent selected:border-transparent pressed:border-transparent',
        'transition-all',
        className,
      )}
      {...props}
    >
      {Icon && <Icon className="h-3 w-3" />}
      <span>{children}</span>
    </AriaTab>
  )
})
Tab.displayName = 'Tab'

const TabPanel = forwardRef(({ children, className, ...props }, ref) => {
  return (
    <AriaTabPanel
      ref={ref}
      className={cn(
        'mt-2 ring-offset-background',
        'focus-visible:ring-2 focus-visible:ring-ring',
        'focus-visible:ring-offset-2 focus-visible:outline-none',
        className,
      )}
      {...props}
    >
      {children}
    </AriaTabPanel>
  )
})
TabPanel.displayName = 'TabPanel'

// Compound component pattern
Tabs.List = TabsList
Tabs.Tab = Tab
Tabs.Panel = TabPanel

// Set displayName for TopBar detection
Tabs.displayName = 'TopBar.Tabs'

export { Tab, TabPanel, Tabs, TabsList }
export default Tabs
